/**
 * @file index.tsx
 *
 * @fileoverview Renders a FlexItems.
 */
import React from "react";
import {
  AlignItemsProps,
  JustifyContentProps,
} from "../../../../theme/layout/itemsLayout";
import { getScopedClasses } from "../../../../utils/responsive";
import styles from "./flex.module.scss";

type FlexDirectionProps = "row" | "column" | "row-reverse" | "column-reverse";

type FlexWrapProps = "wrap" | "nowrap" | "wrap-reverse";

interface FlexItemsProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The content to be displayed inside the chip element.
   *
   * @default "null"
   */
  children: React.ReactNode | string;
  /**
   * Responsive flex direction prop.
   */
  flexDirection?: FlexDirectionProps | FlexDirectionProps[];
  /**
   * Responsive align items prop.
   */
  alignItems?: AlignItemsProps | AlignItemsProps[];
  /**
   * Responsive align items prop.
   */
  flexWrap?: FlexWrapProps | FlexWrapProps[];
  /**
   * Responsive justify content prop.
   */
  justifyContent?: JustifyContentProps | JustifyContentProps[];
  /**
   * Responsive gap property connected to the space utility in theme.
   */
  gap?: number | number[];
  /**
   * The className.
   * This prop gets appended to the already existing classes.
   */
  className?: string;
}

export const FlexItems = ({
  children,
  gap,
  flexDirection,
  alignItems,
  flexWrap = "wrap",
  justifyContent,
  className = "",
  ...props
}: FlexItemsProps) => {
  return (
    <div
      {...props}
      className={`
      flex-item-wrapper
      ${styles.flexItems}
      ${getScopedClasses(styles, "fd", flexDirection)}
      ${getScopedClasses(styles, "ai", alignItems)}
      ${getScopedClasses(styles, "fw", flexWrap)}
      ${getScopedClasses(styles, "jc", justifyContent)}
      ${getScopedClasses(styles, "gap", gap)}
      ${className}
      `.trim()}
    >
      {children}
    </div>
  );
};
export default FlexItems;
